import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { VariaveisCursorPayload } from '@shared/components/formula/variaveis-disponiveis-dialog/variaveis-disponiveis-dialog.component';
import { ObservacaoEditorComponent } from '@shared/components/formula/observacao-editor/observacao-editor.component';

/** Seção das informações complementares da regra (mesma composição da seção de observação da aba ICMS da natureza). */
@Component({
    selector: 'app-regra-tributaria-observacao-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, ObservacaoEditorComponent],
    templateUrl: './regra-tributaria-observacao-section.component.html',
    styleUrl: './regra-tributaria-observacao-section.component.css',
})
export class RegraTributariaObservacaoSectionComponent {
    @Input({ required: true }) control!: FormControl;
    /** Variáveis do CST/cClassTrib selecionados; vazia desabilita o link do modal. */
    @Input() variaveis: VariavelStruct[] = [];
    @Input() isClassificacaoInformada = false;

    @Output() abrirVariaveis = new EventEmitter<VariaveisCursorPayload>();

    public onClicarVariaveis(editor: ObservacaoEditorComponent): void {
        if (this.variaveis.length === 0) return;
        this.abrirVariaveis.emit({ control: this.control, selectionStart: 0, selectionEnd: 0, editor });
    }
}
